export enum LineItemComparisonRowType {
    PRODUCT = 'product',
    SAMPLE_KIT = 'sampleKit',
}
